import {MenuInterface} from "../../../interface/menu.interface";
import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import {config} from "../../../common/config/config";
import {styles} from "../../../common/style";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {FleaMarket} from "../../../interface/fleaMarket.interface";
import {isMobile} from "react-device-detect";


let class_1 = {
    width: isMobile? 1: 0.5,
    display: 'flex',
    justifyContent: 'flex-start', alignItems: 'center',
    mb: 1,
    border: styles.border,
    backgroundColor: 'var(--scc-surface)', borderRadius: 1,
}

let class_2 = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 1,
    p: 2,
    width: 100,
    backgroundColor: '#696969'
}

export default function FleaMarketBoardInputComponent(props: {
    menu: MenuInterface,
    state: any,
    setState: any,
    refs: {
        fmCategoryRef: any,
        fmProductNameRef: any,
        fmBrandRef: any,
        fmModelNoRef: any,
        fmPurchasePriceRef: any,
        fmSellingPriceRef: any,
    },
    changeShareStatus: any,
    changeAmount: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void,
    isUpdatePage: boolean
}) {

    return <Box sx={{width: 1, display: 'flex', flexWrap: 'wrap'}}>

        {/* 상태값 Input */}
        <Box sx={{...class_1, width: 1}} >
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 상태 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby=""
                        name="position"
                        defaultValue="top"
                        onChange={(e) => props.changeShareStatus(e)}
                    >
                        <FormControlLabel
                            value="0"
                            checked={props.state.shareStatus == 0 ? true : false}
                            control={<Radio/>}
                            label="판매 중"
                            labelPlacement="start"
                        />
                        <FormControlLabel
                            disabled={props.isUpdatePage ? false : true}
                            checked={props.state.shareStatus == 1 ? true : false}
                            value="1"
                            control={<Radio/>}
                            label="판매완료"
                            labelPlacement="start"
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
        </Box>

{/*
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 카테고리 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmCategoryRef}
                           placeholder="카테고리를 입력해주세요."
                           label="" variant="outlined"
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>*/}

        {/* 제품명 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 제품명 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmProductNameRef}
                           placeholder="제품명을 입력해주세요."
                           label="" variant="outlined"
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>


        {/* 플리마켓 게시판 전용 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 수량 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField type={'number'}
                           value={props.state.amount}
                           onChange={(e) => props.changeAmount(e)}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}/>
            </Box>
        </Box>


        {/* 브랜드명 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 브랜드명 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmBrandRef}
                           placeholder="브랜드명을 입력해주세요."
                           label="" variant="outlined"
                           defaultValue={""}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>

        {/* 모델명 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 모델명 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmModelNoRef}
                           placeholder="모델명을 입력해주세요."
                           label="" variant="outlined"
                           defaultValue={""}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>

        {/* 구매가격 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 구매가격 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmPurchasePriceRef}
                           placeholder="구매가격을 입력해주세요."
                           label="" variant="outlined"
                           type={"number"}
                           defaultValue={0}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>

        {/* 시작가격 Input */}
        <Box sx={class_1}>
            <Box sx={class_2}>
                <Typography sx={{color: 'white'}}> 시작가격 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField inputRef={props.refs.fmSellingPriceRef}
                           placeholder="시작가격을 입력해주세요."
                           label="" variant="outlined"
                           type={"number"}
                           defaultValue={0}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}
                />
            </Box>
        </Box>
    </Box>;
}
